import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MessageCircle } from "lucide-react";

export default function WhatsAppFloat() {
  const [showHint, setShowHint] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setShowHint(true), 5000);
    const t2 = setTimeout(() => setShowHint(false), 12000);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, []);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex items-center gap-3">
      <AnimatePresence>
        {showHint && (
          <motion.button
            data-testid="whatsapp-float-hint"
            initial={{ opacity: 0, x: 16, scale: 0.95 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, x: 16, scale: 0.95 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            onClick={() => window.open("https://wa.me/558594032594?text=" + encodeURIComponent("Olá! Quero saber mais sobre a CliniAtiva."), "_blank")}
            className="hidden rounded-2xl rounded-br-sm bg-white px-4 py-3 text-left text-sm font-medium text-navy shadow-[0_16px_40px_rgba(16,42,67,0.25)] sm:block"
          >
            Fale com a gente agora —
            <span className="block text-xs text-[#546B7C]">resposta em minutos</span>
          </motion.button>
        )}
      </AnimatePresence>

      <motion.a
        data-testid="whatsapp-float-button"
        href="https://wa.me/558594032594?text=Ol%C3%A1!%20Quero%20saber%20mais%20sobre%20a%20CliniAtiva."
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Conversar no WhatsApp"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1.6, type: "spring", stiffness: 260, damping: 18 }}
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.94 }}
        className="ping-ring relative flex h-16 w-16 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_16px_40px_rgba(37,211,102,0.45)]"
      >
        <MessageCircle className="h-7 w-7 fill-white" />
        <span className="absolute -right-1 -top-1 flex h-6 w-6 items-center justify-center rounded-full border-2 border-white bg-[#D64F4F] font-display text-[11px] font-bold text-white">
          1
        </span>
      </motion.a>
    </div>
  );
}
